import { Link } from "react-router-dom";

export const Logo = ({ light = false, className = "h-8 sm:h-9" }) => (
  <Link to="/" data-testid="site-logo-link" className="flex shrink-0 items-center transition-opacity hover:opacity-80">
    <img
      src={light ? "/brand/horizontal-white.webp" : "/brand/horizontal-blue.webp"}
      alt="Victory Parañaque"
      className={`${className} w-auto`}
    />
  </Link>
);
